export const BASE_CLASS_NAME = 'ui-menu';
